import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import OrderingListMixin from 'Mixins/OrderingListMixin';
import { IOrderingListFilter } from 'Store/OrderingList';


@Component({
    template: "#ordering-list-filter-template"
})
export default class OrderingListFilterComponent extends mixins(BaseComponent,OrderingListUserMixin, OrderingListMixin) {

    async created(){
        await store.dispatch.orderingList.loadFilter();

        //set default value if filter is empty
        if((this.filter.showFromMasterList == null || this.filter.showFromMasterList == undefined)  && this.scopeIsYourSortimentList){
            store.state.orderingList.filter.showFromMasterList = true;
        }
    }


    //v-model out of this..
    get filter(): IOrderingListFilter{
        return store.getters.orderingList.filter;
    }

    filterChanged(value: IOrderingListFilter){
        store.dispatch.orderingList.updateFilter(value);
    }


    get show(){
        return store.state.orderingList.currentOrderingList?.permissions?.canAdditemFromParent;
    }
}

Vue.component('orderinglist-filter', OrderingListFilterComponent);

